import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import {
  FaMobileAlt,
  FaTv,
  FaReceipt,
  FaGift,
  FaShieldAlt,
  FaClock,
  FaRupeeSign,
  FaHeadset,
} from "react-icons/fa";

const ServicesPage = () => {
  const services = [
    {
      icon: <FaMobileAlt />,
      title: "Mobile Recharge",
      description:
        "Instant prepaid & postpaid recharges for all major operators",
    },
    {
      icon: <FaTv />,
      title: "DTH Recharge",
      description: "Recharge all DTH providers with best channel packs",
    },
    {
      icon: <FaReceipt />,
      title: "Bill Payments",
      description:
        "Pay electricity, water, gas, broadband and other utility bills",
    },
    {
      icon: <FaGift />,
      title: "Gift Vouchers",
      description:
        "Purchase digital gift cards for popular brands and services",
    },
  ];

  const whyChooseUs = [
    {
      icon: <FaShieldAlt />,
      title: "100% Secure",
      description: "Bank-grade encryption for all transactions",
    },
    {
      icon: <FaClock />,
      title: "Instant Processing",
      description: "Most services activated within seconds",
    },
    {
      icon: <FaRupeeSign />,
      title: "No Hidden Fees",
      description: "Transparent pricing with no surprises",
    },
    {
      icon: <FaHeadset />,
      title: "24/7 Support",
      description: "Dedicated customer care always available",
    },
  ];

  return (
    <React.Fragment>
      <Header />

      <div className="services-page">
        <Helmet>
          <title>Our Services - Topup Connect</title>
          <meta
            name="description"
            content="Mobile recharge, DTH recharge, bill payments and gift vouchers - all in one place"
          />
        </Helmet>

        <section className="services-hero">
          <div className="container">
            <h1>Our Services</h1>
            <p>Everything you need for digital payments in one place</p>
          </div>
        </section>

        <div className="container services-container">
          <section className="main-services">
            <h2>Core Services</h2>
            <div className="services-grid">
              {services.map((service, index) => (
                <div className="service-card" key={index}>
                  <div className="icon-wrapper">{service.icon}</div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="benefits-section">
            <h2>Why Choose Us</h2>
            <div className="benefits-grid">
              {whyChooseUs.map((benefit, index) => (
                <div className="benefit-card" key={index}>
                  <div className="benefit-icon">{benefit.icon}</div>
                  <h4>{benefit.title}</h4>
                  <p>{benefit.description}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </React.Fragment>
  );
};

export default ServicesPage;
